import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const updatePUblisherStoreAction = createAsyncThunk(
    'update-publisher-store',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.put(`/admins/api/update-publisher-store`,{ ...data }) 
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const updatePublisherStoreSlice = createSlice({
    name: 'update-publisher-store',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(updatePUblisherStoreAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(updatePUblisherStoreAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(updatePUblisherStoreAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const UpdatePublisherStoreReducer = updatePublisherStoreSlice.reducer